// pdfmake ile Türkçe PDF oluşturma utility
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

// pdfmake'e fontları ekle
if (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
}

/**
 * pdfmake ile tablo PDF'i oluştur
 * @param {string} title - PDF başlığı
 * @param {string} subtitle - Alt başlık (opsiyonel)
 * @param {Array} headers - Tablo başlıkları
 * @param {Array} data - Tablo verileri
 * @param {string} filename - İndirilecek dosya adı
 */
export const createTablePDF = (title, subtitle, headers, data, filename) => {
  const docDefinition = {
    content: [
      {
        text: title,
        style: 'header',
        margin: [0, 0, 0, 10]
      },
      subtitle ? {
        text: subtitle,
        style: 'subheader',
        margin: [0, 0, 0, 10]
      } : null,
      {
        table: {
          headerRows: 1,
          widths: Array(headers.length).fill('auto'),
          body: [
            headers.map(h => ({ text: h, style: 'tableHeader' })),
            ...data
          ]
        },
        layout: {
          fillColor: function (rowIndex) {
            return rowIndex === 0 ? '#3b82f6' : (rowIndex % 2 === 0 ? '#f9fafb' : null);
          },
          hLineColor: () => '#e5e7eb',
          vLineColor: () => '#e5e7eb'
        }
      }
    ].filter(Boolean),
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        color: '#1f2937'
      },
      subheader: {
        fontSize: 12,
        color: '#6b7280'
      },
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: 'white'
      }
    },
    defaultStyle: {
      fontSize: 9,
      font: 'Roboto' // Roboto fontu Türkçe karakterleri destekler
    },
    pageOrientation: 'landscape',
    pageMargins: [40, 60, 40, 60]
  };

  pdfMake.createPdf(docDefinition).download(filename);
};

/**
 * pdfmake ile basit PDF oluştur (sadece metin)
 */
export const createSimplePDF = (title, content, filename) => {
  const docDefinition = {
    content: [
      {
        text: title,
        style: 'header',
        margin: [0, 0, 0, 20]
      },
      {
        text: content,
        style: 'content'
      }
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true
      },
      content: {
        fontSize: 12
      }
    },
    defaultStyle: {
      font: 'Roboto'
    }
  };

  pdfMake.createPdf(docDefinition).download(filename);
};

export default pdfMake;
